import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import { Inbox, BarChart3, Users, FileText, UserPlus, Mail, Link2, LogOut, User, Video, Search, Lightbulb, Network, MessageCircle, Image as ImageIcon, Activity, Send, LayoutDashboard, Radio } from "lucide-react";
import { isPartner, getPartnerMeta, logout, loginUrl } from "../lib/adminAuth";
import MailHistoryLookup from "./admin/MailHistoryLookup";

const ADMIN_TABS = [
  { to: "/admin", label: "Anfragen", icon: Inbox, match: (p) => p === "/admin" },
  { to: "/admin/uebersicht", label: "Übersicht", icon: LayoutDashboard, match: (p) => p.startsWith("/admin/uebersicht") },
  { to: "/admin/track-record", label: "Performance", icon: BarChart3, match: (p) => p.startsWith("/admin/track-record") || p.startsWith("/admin/analytics") },
  { to: "/admin/master-feed", label: "Master-Feed", icon: Radio, match: (p) => p.startsWith("/admin/master-feed") },
  { to: "/admin/partners", label: "Partner", icon: Users, match: (p) => p === "/admin/partners" || (p.startsWith("/admin/partners") && !p.startsWith("/admin/partner-reach")) },
  { to: "/admin/partner-reach", label: "Reach", icon: MessageCircle, match: (p) => p.startsWith("/admin/partner-reach") },
  { to: "/admin/blog", label: "Blog", icon: FileText, match: (p) => p.startsWith("/admin/blog") },
  { to: "/admin/onboarding-customers", label: "Onboarding", icon: UserPlus, match: (p) => p.startsWith("/admin/onboarding-customers") },
  { to: "/admin/links", label: "Links", icon: Link2, match: (p) => p.startsWith("/admin/links") },
  { to: "/admin/coaching", label: "Coaching", icon: Lightbulb, match: (p) => p.startsWith("/admin/coaching") || p.startsWith("/partner/coaching") },
  { to: "/admin/webinars", label: "Webinar", icon: Video, match: (p) => p.startsWith("/admin/webinars") },
  { to: "/admin/wochenbericht", label: "Social Media", icon: ImageIcon, match: (p) => p.startsWith("/admin/wochenbericht") || p.startsWith("/admin/monatsbericht") },
  { to: "/admin/mail-engagement", label: "Engagement", icon: Activity, match: (p) => p.startsWith("/admin/mail-engagement") },
  { to: "/admin/mail-test", label: "Mail-Test", icon: Mail, match: (p) => p.startsWith("/admin/mail-test") },
  { to: "/admin/broadcast", label: "Broadcast", icon: Send, match: (p) => p.startsWith("/admin/broadcast") },
];

const PARTNER_TABS = [
  { to: "/admin", label: "Anfragen", icon: Inbox, match: (p) => p === "/admin" },
  { to: "/partner/onboarding", label: "Onboarding", icon: UserPlus, match: (p) => p.startsWith("/partner/onboarding") },
  { to: "/partner/links", label: "Links", icon: Link2, match: (p) => p.startsWith("/partner/links") || p.startsWith("/admin/links") },
  { to: "/partner/downline", label: "Meine Struktur", icon: Network, match: (p) => p === "/partner" || p.startsWith("/partner/downline") },
  { to: "/partner/coaching", label: "Coaching", icon: Lightbulb, match: (p) => p.startsWith("/partner/coaching") },
  { to: "/partner/profile", label: "Mein Profil", icon: User, match: (p) => p.startsWith("/partner/profile") },
];

export default function AdminTopNav() {
  const { pathname } = useLocation();
  const partnerMode = isPartner();
  const TABS = partnerMode ? PARTNER_TABS : ADMIN_TABS;
  const meta = partnerMode ? getPartnerMeta() : null;
  const [historyOpen, setHistoryOpen] = useState(false);
  const adminToken = typeof window !== "undefined" ? localStorage.getItem("alphalane_admin_token") : null;
  return (
    <div className="border-b border-[var(--al-line)] bg-white">
      <nav className="max-w-7xl mx-auto px-5 sm:px-8 flex items-center gap-1 overflow-x-auto" data-testid="admin-top-nav">
        {TABS.map((tab) => {
          const Icon = tab.icon;
          const active = tab.match(pathname);
          return (
            <Link
              key={tab.to}
              to={tab.to}
              data-testid={`tab-${tab.to.replace(/\//g, "-")}`}
              className={`flex items-center gap-2 px-3 sm:px-4 py-3 text-sm font-display font-medium border-b-2 transition-colors whitespace-nowrap ${
                active
                  ? "border-[var(--al-purple)] text-[var(--al-purple)]"
                  : "border-transparent text-slate-500 hover:text-slate-900 hover:border-slate-200"
              }`}
            >
              <Icon className="h-4 w-4" /> {tab.label}
            </Link>
          );
        })}
        {!partnerMode && (
          <button
            onClick={() => setHistoryOpen(true)}
            data-testid="open-mail-history"
            title="Mail-History pro E-Mail-Adresse durchsuchen"
            className="ml-auto flex items-center gap-1.5 px-3 py-1.5 mr-1 my-2 rounded-lg text-xs font-display font-semibold text-slate-600 hover:text-violet-700 hover:bg-violet-50 border border-slate-200 hover:border-violet-300 transition-colors whitespace-nowrap"
          >
            <Search className="h-3.5 w-3.5" /> Mail-History
          </button>
        )}
        {meta && (
          <div className="ml-auto flex items-center gap-3 pr-2">
            <span className="text-xs text-slate-500" data-testid="partner-name-badge">
              {meta.name}
            </span>
            <button
              onClick={() => { const url = loginUrl(); logout(); window.location.href = url; }}
              data-testid="partner-logout"
              className="text-xs font-semibold text-slate-500 hover:text-rose-600 flex items-center gap-1"
            >
              <LogOut className="h-3.5 w-3.5" /> Logout
            </button>
          </div>
        )}
      </nav>
      <MailHistoryLookup open={historyOpen} onClose={() => setHistoryOpen(false)} token={adminToken} />
    </div>
  );
}
